import { DataBean } from "../DataBean";

export class CertificateYears extends DataBean {



    public async getInfoForTaxCertificateYears(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInfoForTaxCertificateYears_Number", [id]);
    }
    
}